module.exports = __webpack_public_path__ + "img/property5.04ecf61f.png";